const ITEMS = [
  "Transporte Ejecutivo",
  "Logística Deportiva",
  "Protocolo VIP",
  "Ciudad Garaje",
  "Venezuela",
];

export default function Marquee() {
  const half = [...ITEMS, ...ITEMS];
  return (
    <div
      className="relative overflow-hidden border-y border-line bg-[#0A0E14] py-6"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {[0, 1].map((h) => (
          <div key={h} className="flex items-center">
            {half.map((item, i) => (
              <span key={`${h}-${i}`} className="flex items-center">
                <span className="px-8 font-serif text-2xl sm:text-3xl text-slate-500 italic">
                  {item}
                </span>
                <span className="text-gold text-sm">•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
